(function () {
  "use strict";

  var __ = function (s) {
    var args = arguments;
    if (typeof window.__ === "function") return window.__.apply(null, args);
    return String(s).replace(/\{(\d)\}/g, function (m, n) { return args[+n + 1] != null ? args[+n + 1] : m; });
  };

  var CLOSE_DELAY = 280;
  var hoverMedia = window.matchMedia("(hover: hover) and (pointer: fine)");
  var mobileMedia = window.matchMedia("(max-width: 991px)");

  var boundary = null;
  var host = null;
  var panel = null;
  var trigger = null;
  var triggers = [];
  var mainNav = null;
  var utilityBar = null;
  var stuckFrame = null;
  var mobileTrigger = null;
  var primaryNav = null;
  var closeTimer = null;
  var interaction = null;
  var isOpen = false;
  var navOpen = false;
  var fitFrame = null;
  var suppressFocusOpen = false;
  var subnavItems = [];

  function activeCategory() {
    return (host && host.getAttribute("data-store-mega-active-category")) || "guitars";
  }

  function cancelClose() {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = window.setTimeout(function () {
      close();
    }, CLOSE_DELAY);
  }

  function syncBodyMenuState() {
    document.body.classList.toggle("store-menu-active", isOpen);
    document.body.classList.toggle("store-menu-open", isOpen && mobileMedia.matches);
  }

  function setActivePanel(categoryId) {
    host.querySelectorAll("[data-store-mega-preview]").forEach(function (el) {
      var on = el.getAttribute("data-store-mega-preview") === categoryId;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });
    host.querySelectorAll("[data-store-mega-preview-label]").forEach(function (el) {
      var on = el.getAttribute("data-store-mega-preview-label") === categoryId;
      el.classList.toggle("is-active", on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    });
    host.querySelectorAll("[data-store-mega-category-panel]").forEach(function (el) {
      el.hidden = el.getAttribute("data-store-mega-category-panel") !== categoryId;
    });
  }

  function fitPreviewLabels() {
    if (fitFrame) window.cancelAnimationFrame(fitFrame);
    fitFrame = window.requestAnimationFrame(function () {
      fitFrame = null;
      host.querySelectorAll("[data-store-mega-preview-label]").forEach(function (label) {
        label.style.fontSize = "";
        var size = parseFloat(window.getComputedStyle(label).fontSize) || 15;
        var steps = 0;
        while (label.scrollWidth > label.clientWidth && size > 9 && steps < 40) {
          size -= 0.5;
          steps += 1;
          label.style.fontSize = size + "px";
        }
      });
    });
  }

  function open(categoryId, mode) {
    cancelClose();
    interaction = mode;
    isOpen = true;
    panel.hidden = false;
    panel.setAttribute("aria-hidden", "false");
    if ("inert" in panel) panel.inert = false;
    panel.classList.add("is-open");
    host.classList.add("is-open");
    triggers.forEach(function (t) {
      t.setAttribute("aria-expanded", "true");
      t.classList.add("is-previewed");
    });
    setActivePanel(categoryId || activeCategory());
    syncBodyMenuState();
    fitPreviewLabels();
  }

  function close(options) {
    cancelClose();
    if (!isOpen) return;
    isOpen = false;
    interaction = null;
    panel.classList.remove("is-open");
    panel.hidden = true;
    panel.setAttribute("aria-hidden", "true");
    if ("inert" in panel) panel.inert = true;
    host.classList.remove("is-open");
    triggers.forEach(function (t) {
      t.setAttribute("aria-expanded", "false");
      t.classList.remove("is-previewed");
    });
    setActivePanel(activeCategory());
    syncBodyMenuState();
    if (options && options.restoreFocus) {
      suppressFocusOpen = true;
      trigger.focus();
      suppressFocusOpen = false;
    }
  }

  function setMobileNavOpen(open) {
    if (open && !mobileMedia.matches) open = false;
    navOpen = open;
    if (!open) closeSubnavs(null);
    if (mobileTrigger) {
      mobileTrigger.setAttribute("aria-expanded", open ? "true" : "false");
      var site = boundary.classList.contains("site-header--site");
      mobileTrigger.setAttribute("aria-label", site ? (open ? __("Close navigation") : __("Open navigation")) : (open ? __("Close store navigation") : __("Open store navigation")));
    }
    if (primaryNav) {
      primaryNav.classList.toggle("is-mobile-open", open);
      if (mobileMedia.matches) {
        primaryNav.setAttribute("aria-hidden", open ? "false" : "true");
      } else {
        primaryNav.removeAttribute("aria-hidden");
      }
    }
    document.body.classList.toggle("store-mobile-nav-open", open);
  }

  function desktopHoverAllowed() {
    return hoverMedia.matches && !mobileMedia.matches;
  }

  function syncResponsiveOpenState() {
    if (!mobileMedia.matches) {
      setMobileNavOpen(false);
    } else if (primaryNav) {
      primaryNav.setAttribute("aria-hidden", navOpen ? "false" : "true");
    }
    if (isOpen) {
      open(currentPanelId(), interaction || "click");
    } else {
      syncBodyMenuState();
    }
  }

  function currentPanelId() {
    var visible = host.querySelector("[data-store-mega-category-panel]:not([hidden])");
    return visible ? visible.getAttribute("data-store-mega-category-panel") : activeCategory();
  }

  function syncStuck() {
    stuckFrame = null;
    var stuck = !mobileMedia.matches && mainNav.getBoundingClientRect().bottom <= utilityBar.getBoundingClientRect().bottom + 0.5;
    boundary.classList.toggle("is-stuck", stuck);
  }

  function scheduleStuck() {
    if (!stuckFrame) stuckFrame = window.requestAnimationFrame(syncStuck);
  }

  function bindTrigger(t) {
    t.addEventListener("click", function (event) {
      event.preventDefault();
      trigger = t;
      if (isOpen && interaction === "click") {
        close();
      } else {
        open(t.getAttribute("data-store-category"), "click");
      }
    });

    t.addEventListener("pointerenter", function () {
      trigger = t;
      if (desktopHoverAllowed()) open(t.getAttribute("data-store-category"), "hover");
    });

    t.addEventListener("focus", function () {
      if (suppressFocusOpen) return;
      trigger = t;
      if (!mobileMedia.matches) open(t.getAttribute("data-store-category"), "keyboard");
    });
  }

  function closeSubnavs(except) {
    subnavItems.forEach(function (item) {
      if (item === except) return;
      item.classList.remove("is-open");
      var t = item.querySelector("[data-site-subnav-toggle]");
      if (t) t.setAttribute("aria-expanded", "false");
    });
  }

  function bindSubnavs() {
    subnavItems.forEach(function (item) {
      var toggle = item.querySelector("[data-site-subnav-toggle]");
      if (toggle) {
        toggle.addEventListener("click", function () {
          var open = !item.classList.contains("is-open");
          closeSubnavs(item);
          item.classList.toggle("is-open", open);
          toggle.setAttribute("aria-expanded", open ? "true" : "false");
        });
      }
      item.addEventListener("keydown", function (event) {
        if (event.key !== "Escape" || mobileMedia.matches || !item.querySelector(".site-subnav")) return;
        event.preventDefault();
        event.stopPropagation();
        item.classList.add("is-suppressed");
        var link = item.querySelector(".site-nav-link");
        if (link) link.focus();
      });
      item.addEventListener("pointerleave", function () { item.classList.remove("is-suppressed"); });
      item.addEventListener("focusout", function (event) {
        if (!item.contains(event.relatedTarget)) item.classList.remove("is-suppressed");
      });
    });
  }

  function bindMega() {
    triggers.forEach(bindTrigger);

    host.addEventListener("pointerover", function (event) {
      if (!desktopHoverAllowed()) return;
      var preview = event.target.closest("[data-store-mega-preview],[data-store-mega-preview-label]");
      if (preview) {
        cancelClose();
        setActivePanel(preview.getAttribute("data-store-mega-preview") || preview.getAttribute("data-store-mega-preview-label"));
      }
    });

    host.addEventListener("click", function (event) {
      var navTarget = event.target.closest("[data-store-mega-preview],[data-store-mega-preview-label]");
      if (navTarget) {
        event.preventDefault();
        var href = navTarget.getAttribute("data-href");
        if (href) window.location.href = href;
        return;
      }
      if (event.target.closest("[data-store-mega-close]")) {
        close({ restoreFocus: true });
      }
    });
  }

  function bind() {
    if (host) bindMega();
    bindSubnavs();

    boundary.addEventListener("pointerenter", cancelClose);
    boundary.addEventListener("pointerleave", function () {
      if (isOpen && interaction === "hover") scheduleClose();
    });

    boundary.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (isOpen) {
        event.preventDefault();
        close({ restoreFocus: true });
      } else if (navOpen) {
        event.preventDefault();
        setMobileNavOpen(false);
        if (mobileTrigger) mobileTrigger.focus();
      }
    });

    boundary.addEventListener("focusout", function () {
      window.setTimeout(function () {
        var focused = document.activeElement;
        if (focused && boundary.contains(focused)) return;
        if (isOpen && interaction !== "hover") close();
        if (navOpen) setMobileNavOpen(false);
      }, 0);
    });

    document.addEventListener("pointerdown", function (event) {
      if (boundary.contains(event.target)) return;
      if (isOpen) close();
      if (navOpen) setMobileNavOpen(false);
    });

    if (mobileTrigger) {
      mobileTrigger.addEventListener("click", function () {
        if (navOpen) {
          setMobileNavOpen(false);
        } else {
          close();
          setMobileNavOpen(true);
        }
      });
    }

    var mediaHandler = function () {
      syncResponsiveOpenState();
      scheduleStuck();
    };
    if (typeof mobileMedia.addEventListener === "function") {
      mobileMedia.addEventListener("change", mediaHandler);
    } else if (typeof mobileMedia.addListener === "function") {
      mobileMedia.addListener(mediaHandler);
    }

    window.addEventListener("resize", function () {
      if (isOpen) fitPreviewLabels();
      if (mainNav && utilityBar) scheduleStuck();
    });

    if (mainNav && utilityBar) {
      window.addEventListener("scroll", scheduleStuck, { passive: true });
      scheduleStuck();
    }

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === "function") {
      document.fonts.ready.then(function () {
        if (isOpen) fitPreviewLabels();
      });
    }
  }

  function init() {
    boundary = document.querySelector(".site-header");
    if (!boundary) return;
    host = boundary.querySelector("[data-store-mega-host]");
    panel = boundary.querySelector("[data-store-mega-panel]");
    triggers = Array.prototype.slice.call(boundary.querySelectorAll("[data-store-browse-trigger]"));
    trigger = triggers[0] || null;
    mainNav = boundary.querySelector(".main-nav");
    utilityBar = boundary.querySelector(".utility-bar");
    mobileTrigger = boundary.querySelector("[data-store-mobile-nav-trigger]");
    primaryNav = boundary.querySelector("[data-store-primary-nav]");
    subnavItems = Array.prototype.slice.call(boundary.querySelectorAll("[data-site-nav-item]"));
    if (!host || !panel || !trigger) {
      host = null;
      panel = null;
    } else if ("inert" in panel) {
      panel.inert = true;
    }
    if (primaryNav && mobileMedia.matches) primaryNav.setAttribute("aria-hidden", "true");
    bind();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
